import { FC } from 'react';

import { Image } from 'src/general/components/Image/Image';
import { FinanceLogoIcon } from 'src/hygiene/templates/FinanceLogoIcon/FinanceLogoIcon';

type FinanceDescriptionContentProps = {
  sectionData: {
    title: string;
    subtitle: string;
    financeUSPs: {
      icon: string;
      description: string;
    }[];
    lenderIntro: string;
    lenders: {
      icon: string;
    }[];
  };
};

export const FinanceDescriptionContent: FC<FinanceDescriptionContentProps> = ({ sectionData }) => {
  return (
    <div className="flex-1">
      <div className="mb-6 sm:mb-8">
        <h1 className="c-fs-h4 mb-5 font-extrabold sm:w-[75%] md:w-full">{sectionData.title}</h1>
        {sectionData.subtitle && <p className="c-fs-body2">{sectionData.subtitle}</p>}
      </div>
      <div className="mb-12 flex flex-col gap-6 sm:mb-9 sm:flex-row md:mb-8 lg:mb-14">
        {sectionData.financeUSPs.map((item) => (
          <div className="flex items-center gap-3 sm:gap-2 md:flex-col" key={item.icon}>
            <Image src={item.icon} alt={item.description} width={40} height={40} />
            <span className="c-fs-body2">{item.description}</span>
          </div>
        ))}
      </div>
      <div className="sm:flex sm:items-stretch sm:gap-5 md:mt-6 md:flex-col">
        <div className="md:flex md:items-stretch md:gap-4">
          <span className="sm:flex sm:items-center md:w-[138px]">
            <p className="c-fs-body2 font-normal">{sectionData.lenderIntro}</p>
          </span>
          <div className="hidden w-px bg-for-pri-bas sm:block" />
          <div className="mt-2 flex flex-wrap gap-2 sm:items-center">
            {sectionData.lenders.map((item) => (
              <div key={item.icon} className="flex h-8 w-23 items-end justify-center">
                <FinanceLogoIcon src={item.icon} alt={item.icon} width={92} height={32} />
              </div>
            ))}
          </div>
        </div>
        <div className="relative mt-13 sm:mt-0 md:mt-24">
          <Image
            className="h-21 w-44 sm:h-41 sm:w-100 md:h-46 md:w-114 lg:h-57 lg:w-141"
            src="https://img.carma.com.au/ui-assets/FinanceHeroBanner/finance-car.png"
            width={1068}
            height={433}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
